import React from 'react';
import { useTranslation } from 'react-i18next';
import { URL_WORKFLOW } from '../../constance/urls';
import { useHistory } from 'react-router-dom';
import { PATH } from '../../routes/Routes';
import { Button, Select, Form, DatePicker, Input, Row, Col } from 'antd';
import TSTable from '../common/TSTable';
import * as _ from "lodash";
import { DATE_FORMAT, HUMAN_DATE_FORMAT } from '../../constance/strings';
import dayjs from 'dayjs';
import { useDebounce } from 'use-debounce';
import { BLUE_COLOR } from '../../constance/color';
import ColorButton from '../common/ColorButton';

export default function WoodImportList() {

  const history = useHistory();
  const { t } = useTranslation();
  const tableRef = React.useRef();
  const [form] = Form.useForm();
  const typeFilter = Form.useWatch('type', form)
  const date = Form.useWatch('produce_date', form)
  const searchText = Form.useWatch('search', form)
  const [debouncedText] = useDebounce(searchText, 500);
  const formattedDate = date ? dayjs(date).format(DATE_FORMAT) : null;

  React.useEffect(() => {
    if (tableRef.current) {
      tableRef.current.fetch();
    }
  }, [date, typeFilter, debouncedText])

  const columns = React.useMemo(() => [

    {
      title: t('date'),
      dataIndex: 'wood_import.produce_date',
      render: (__, original) => new Date(original.wood_import.produce_date).toLocaleString('en-GB'),
    },
    {
      title: t('wood_imports.order_no'),
      dataIndex: 'wood_import.order_no',
      render: (__, original) => {
        return _.get(original, 'wood_import.order_no', '-')
      },
    },
    {
      title: t('truck_transactions.company'),
      dataIndex: 'wood_import.truck_company_name',
      render: (__, original) => {
        return _.get(original, 'wood_import.truck_company_name', '-')
      },
    },
    {
      title: t('trucks.type'),
      dataIndex: 'wood_import.truck_type_name',
      render: (__, original) => {
        return _.get(original, 'wood_import.truck_type_name', '-')
      },
    },
    {
      title: () => null,
      dataIndex: 'id',
      render: (value) => (
        <div style={{ textAlign: 'center' }}>
          <ColorButton
            variant='outlined'
            override={BLUE_COLOR}
            color='primary'
            onClick={() => {
              history.push(`${PATH.WOOD_IMPORT}${value}`)
            }}
          >{t('detail')}</ColorButton>
        </div>
      )
    }
  ], []);

  return (
    <div style={{ textAlign: 'left' }}>

      <Form form={form}>
        <Row gutter={16}>
          <Col sm={24} md={12} lg={6}>
            <Form.Item label={t('searchs.fields.date')} name={"produce_date"} >
              <DatePicker
                format={HUMAN_DATE_FORMAT}
                placeholder={t('searchs.placeholders.date')}
                style={{ width: '100%' }}
              />
            </Form.Item>
          </Col>
          <Col sm={24} md={12} lg={6}>
            <Form.Item label={t('wood_imports.vat')} name={"type"} >
              <Select
                defaultValue='ALL'
                options={[
                  { key: 'ALL', value: 'ALL', label: t('datas.total') },
                  { key: 'FACTORY', value: 'FACTORY', label: t('wood_imports.types.factory') },
                  { key: 'CUSTOMER', value: 'CUSTOMER', label: t('wood_imports.types.customer') },
                ]}
              />
            </Form.Item>
          </Col>
          <Col sm={24} md={12} lg={6}>
            <Form.Item label={t('search')} name={"search"} >
              <Input
                placeholder={t('search')}
                allowClear
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>

      <TSTable
        ref={tableRef}
        url={URL_WORKFLOW.WOOD_IMPORT_WORKFLOW}
        columns={columns}
        params={{ date: formattedDate, type: typeFilter, search: debouncedText }}
      />
    </div>
  );
}
